export const UpvoteTooltipLastSeenAtLocalStorageKey = "upvote_tooltip_last_seen_at";
